import { 
    CANCEL_ORDER_REQUEST,
    CANCEL_ORDER_SUCCESS,
    CANCEL_ORDER_FAILURE,
    CANCEL_ORDER_DELETE,
    SAVE_CANCEL_ORDER_REQUEST,
    SAVE_CANCEL_ORDER_SUCCESS,
    SAVE_CANCEL_ORDER_FAILURE,
    CANCEL_ORDER_REASON_LIST_REQUEST,
    CANCEL_ORDER_REASON_LIST_SUCCESS,
    CANCEL_ORDER_REASON_LIST_FAILURE,
 } from '../constants/ActionTypes';

 const initialState = {
     loading : false,
     cancelOrderList : [],
     error : null,
     success: false,
     cancelOrderReasonList: [],
 }

 export default function cancelOrderReducer(state = initialState, action){
    switch (action.type) {
        case CANCEL_ORDER_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case CANCEL_ORDER_SUCCESS:
            return {
                ...state,
                // always replacing data
                
                cancelOrderList: action.data.order_list,
                loading: false,
                
                
            };
        case CANCEL_ORDER_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        case CANCEL_ORDER_DELETE:
                return {
                    ...state,
                    cancelOrderList: [],
                    loading: false,
                };
        case SAVE_CANCEL_ORDER_REQUEST:
                return {
                    ...state,
                    loading: true,
                }
        case SAVE_CANCEL_ORDER_SUCCESS:
                return {
                        ...state,
                        success: true,
                        loading : false,

                }
        case SAVE_CANCEL_ORDER_FAILURE: 
                return {
                    ...state,
                    loading: false,
                    error: action.error
                }
        case CANCEL_ORDER_REASON_LIST_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case CANCEL_ORDER_REASON_LIST_SUCCESS:
            return {
                ...state,
                cancelOrderReasonList: action.data.cancel_reason_list,
                loading: false,
            };
        case CANCEL_ORDER_REASON_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        default:
            return state;
    }

 }